export interface ReasonValues {
  editReason?: string;
  statusReason?: string;
}

export interface ParsedReason {
  legacyReason: string;
  editReason: string;
  statusReason: string;
}

export function combineReasons(values: ReasonValues): string {
  const { editReason = '', statusReason = '' } = values;

  const hasEditReason = editReason?.trim().length > 0;
  const hasStatusReason = statusReason?.trim().length > 0;

  if (hasEditReason && hasStatusReason) {
    return `${editReason}::${statusReason}`;
  } else if (hasStatusReason) {
    return `::${statusReason}`;
  } else if (hasEditReason) {
    return `${editReason}::`;
  } else {
    return '';
  }
}

export function parseReason(reason: string): ParsedReason {
  if (!reason || !reason.includes('::')) {
    return {
      legacyReason: reason,
      editReason: '',
      statusReason: '',
    };
  }

  const [editReason = '', statusReason = ''] = reason.split('::');

  return {
    legacyReason: '',
    editReason: editReason.trim(),
    statusReason: statusReason.trim(),
  };
}
